export type TypographyVariant = (
	'body1'
	| 'body1Strong'
	| 'body2'
	| 'button'
	| 'caption1'
	| 'caption2'
	| 'h1'
	| 'h2'
	| 'h3'
	| 'h4'
	| 'h5'
	| 'h6'
	| 'link'
	| 'subtitle'
	| 'subtitleStrong'
);

export interface TypographyVariantDefinition {
	className: string;
	defaultAs: keyof HTMLElementTagNameMap;
	lineHeightToken: string;
	name: string;
	sizeToken: string;
	weightToken: string;
}

export const typographyVariantDefinitions: Record<TypographyVariant, TypographyVariantDefinition> = {
	h1: {
		className: 'font-heading type-title-1',
		defaultAs: 'h1',
		lineHeightToken: '--type-title-1-leading',
		name: 'H1',
		sizeToken: '--type-title-1-size',
		weightToken: '--type-title-1-weight',
	},
	h2: {
		className: 'font-heading type-title-2',
		defaultAs: 'h2',
		lineHeightToken: '--type-title-2-leading',
		name: 'H2',
		sizeToken: '--type-title-2-size',
		weightToken: '--type-title-2-weight',
	},
	h3: {
		className: 'font-heading type-heading',
		defaultAs: 'h3',
		lineHeightToken: '--type-heading-leading',
		name: 'H3',
		sizeToken: '--type-heading-size',
		weightToken: '--type-heading-weight',
	},
	h4: {
		className: 'font-heading type-subtitle-1',
		defaultAs: 'h4',
		lineHeightToken: '--type-subtitle-1-leading',
		name: 'H4',
		sizeToken: '--type-subtitle-1-size',
		weightToken: '--type-subtitle-1-weight',
	},
	h5: {
		className: 'font-heading type-h5',
		defaultAs: 'h5',
		lineHeightToken: '--type-h5-leading',
		name: 'H5',
		sizeToken: '--type-h5-size',
		weightToken: '--type-h5-weight',
	},
	h6: {
		className: 'font-heading type-h6',
		defaultAs: 'h6',
		lineHeightToken: '--type-h6-leading',
		name: 'H6',
		sizeToken: '--type-h6-size',
		weightToken: '--type-h6-weight',
	},
	subtitle: {
		className: 'font-body type-subtitle',
		defaultAs: 'p',
		lineHeightToken: '--type-subtitle-leading',
		name: 'Subtitle',
		sizeToken: '--type-subtitle-size',
		weightToken: '--type-subtitle-weight',
	},
	subtitleStrong: {
		className: 'font-body-demi type-subtitle-strong',
		defaultAs: 'p',
		lineHeightToken: '--type-subtitle-strong-leading',
		name: 'Subtitle Strong',
		sizeToken: '--type-subtitle-strong-size',
		weightToken: '--type-subtitle-strong-weight',
	},
	body1: {
		className: 'font-body type-body-1',
		defaultAs: 'p',
		lineHeightToken: '--type-body-1-leading',
		name: 'Body 1',
		sizeToken: '--type-body-1-size',
		weightToken: '--type-body-1-weight',
	},
	body1Strong: {
		className: 'font-body-demi type-body-1-strong',
		defaultAs: 'p',
		lineHeightToken: '--type-body-1-strong-leading',
		name: 'Body 1 Strong',
		sizeToken: '--type-body-1-strong-size',
		weightToken: '--type-body-1-strong-weight',
	},
	body2: {
		className: 'font-body type-body-2',
		defaultAs: 'p',
		lineHeightToken: '--type-body-2-leading',
		name: 'Body 2',
		sizeToken: '--type-body-2-size',
		weightToken: '--type-body-2-weight',
	},
	button: {
		className: 'font-body-demi type-button',
		defaultAs: 'span',
		lineHeightToken: '--type-button-leading',
		name: 'Button',
		sizeToken: '--type-button-size',
		weightToken: '--type-button-weight',
	},
	link: {
		className: 'cursor-pointer font-body type-link text-link underline-offset-[0.18em] decoration-[0.06em]',
		defaultAs: 'a',
		lineHeightToken: '--type-link-leading',
		name: 'Link',
		sizeToken: '--type-link-size',
		weightToken: '--type-link-weight',
	},
	caption1: {
		className: 'font-body type-caption',
		defaultAs: 'span',
		lineHeightToken: '--type-caption-leading',
		name: 'Caption 1',
		sizeToken: '--type-caption-size',
		weightToken: '--type-caption-weight',
	},
	caption2: {
		className: 'font-body type-caption-2',
		defaultAs: 'span',
		lineHeightToken: '--type-caption-2-leading',
		name: 'Caption 2',
		sizeToken: '--type-caption-2-size',
		weightToken: '--type-caption-2-weight',
	},
};

export const typographyVariantOptions: TypographyVariant[] = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'subtitle',
	'subtitleStrong',
	'body1',
	'body1Strong',
	'body2',
	'button',
	'link',
	'caption1',
	'caption2',
];
